import { Navigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { PageHeader } from 'components/PageHeader';
import { AuthenticatedCvDataProvider, CVBuilder } from 'modules/cv-builder';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const CVBuilderPage = () => {
  const theme = useTheme();

  const { isEnabled: isCVBuilderEnabled, isLoading } = useFeatureToggle(
    FeatureFlag.PRO_IN_APP_CV_CREATION
  );

  if (isLoading) {
    return null;
  }

  if (!isCVBuilderEnabled && !isLoading) {
    return <Navigate to="/" />;
  }

  return (
    <Layout
      header={
        <PageHeader
          title={getTrans('profilePage.linkLabel.myCv')}
          withBackBtn
        />
      }
      backgroundColor={theme.palette.background.neutral}
      childrenStyles={{
        // Inherit Layout's standard top gap; CV builder just needs full height + no bottom pad.
        pb: 0,
        height: '100%'
      }}
    >
      <AuthenticatedCvDataProvider>
        <CVBuilder />
      </AuthenticatedCvDataProvider>
    </Layout>
  );
};
